import { useEffect, useState } from 'react';
import { Form, Row, Col, Card, Stack } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { formatDate, frenchFormatDate } from '../../helper';
import './eyetestview.css';
import { getSecureItem } from "../../utils/secureStorage";
const Step4 = ({
    setAddEyeTestConfig,
    addEyeTestConfig,
    handleChange,
    glass,
    error,
    view,
    consent = true,
}) => {
    const { t } = useTranslation();
    const user = getSecureItem('UserData');

    // State to track character count errors for each textarea
    const [charLimitErrors, setCharLimitErrors] = useState({
        commentsForPrescription: false,
        noteOpt: false,
        commentaireInterne: false,
        isMutualCompany: false,
        commentForLenses: false,
        comment: false,
        doctorNewComment: false,
    });

    // Handler for textarea changes with character limit validation
    const handleTextareaChange = (e) => {
        const { name, value } = e.target;

        // Check if value exceeds  500 caractères
        if (value.length > 500) {
            setCharLimitErrors((prev) => ({ ...prev, [name]: true }));
        } else {
            setCharLimitErrors((prev) => ({ ...prev, [name]: false }));
        }

        // Call the original handleChange
        handleChange(e);
    };
    return (
        <div>
            <Card
                className={`${view == 'view' ? 'custom_disabled mb-3' : 'mb-3'}`}
            >
                <Card.Body>
                    <Card.Title className="custom_label">
                        {t('langTest')} / # {t('imagesViewed')}
                    </Card.Title>
                    <div>
                        <Stack direction="horizontal" gap={3}>
                            <Form.Check
                                type="radio"
                                id={`0`}
                                label={`0`}
                                name="imagesVues"
                                onChange={(e) => {
                                    setAddEyeTestConfig((prev) => {
                                        return {
                                            ...prev,
                                            imagesVues: e.target.id,
                                        };
                                    });
                                }}
                                checked={addEyeTestConfig.imagesVues === '0'}
                            />
                            <Form.Check
                                type="radio"
                                id={`1`}
                                label={`1`}
                                name="imagesVues"
                                onChange={(e) => {
                                    setAddEyeTestConfig((prev) => {
                                        return {
                                            ...prev,
                                            imagesVues: e.target.id,
                                        };
                                    });
                                }}
                                checked={addEyeTestConfig.imagesVues === '1'}
                            />
                            <Form.Check
                                type="radio"
                                id={`2`}
                                label={`2`}
                                name="imagesVues"
                                onChange={(e) => {
                                    setAddEyeTestConfig((prev) => {
                                        return {
                                            ...prev,
                                            imagesVues: e.target.id,
                                        };
                                    });
                                }}
                                checked={addEyeTestConfig.imagesVues === '2'}
                            />
                            <Form.Check
                                type="radio"
                                id={`3`}
                                label={`3`}
                                name="imagesVues"
                                onChange={(e) => {
                                    setAddEyeTestConfig((prev) => {
                                        return {
                                            ...prev,
                                            imagesVues: e.target.id,
                                        };
                                    });
                                }}
                                checked={addEyeTestConfig.imagesVues === '3'}
                            />
                            <Form.Check
                                type="radio"
                                id={`N/A`}
                                label={`N/A`}
                                name="imagesVues"
                                onChange={(e) => {
                                    setAddEyeTestConfig((prev) => {
                                        return {
                                            ...prev,
                                            imagesVues: e.target.id,
                                        };
                                    });
                                }}
                                checked={addEyeTestConfig.imagesVues === 'N/A'}
                            />
                        </Stack>
                    </div>
                </Card.Body>
            </Card>
            <Card className="mb-3">
                <Card.Body className="modal_form">
                    <Row>
                        <Col
                            md={6}
                            className={`${view == 'view' && user?.userType !== 'EYEDOCTOR'
                                ? 'custom_disabled'
                                : ''
                                }`}
                        >
                            <Form.Group className="mb-5">
                                <Form.Label>
                                    {t('toBeIncludedOnThePrescription')}
                                </Form.Label>

                                {view === 'view' &&
                                    user?.userType !== 'EYEDOCTOR' ? (
                                    // ✅ READONLY MODE — clickable links + copyable
                                    <div
                                        className="border rounded p-2"
                                        style={{
                                            minHeight: '100px',
                                            whiteSpace: 'pre-wrap',
                                            overflowY: 'auto',
                                            resize: 'none',
                                            cursor: 'text',
                                            backgroundColor: '#f8f9fa',
                                            userSelect: 'text',
                                            pointerEvents: 'auto',
                                        }}
                                        onClick={() => {
                                            navigator.clipboard.writeText(
                                                addEyeTestConfig.commentsForPrescription ||
                                                ''
                                            );
                                        }}
                                        title="Click to copy content"
                                        dangerouslySetInnerHTML={{
                                            __html: (
                                                addEyeTestConfig.commentsForPrescription ||
                                                ''
                                            ).replace(
                                                /(https?:\/\/[^\s]+)/g,
                                                '<a href="$1" target="_blank" rel="noopener noreferrer" style="color: #0d6efd; text-decoration: underline;">$1</a>'
                                            ),
                                        }}
                                    ></div>
                                ) : (
                                    // ✅ EDIT MODE — normal textarea
                                    <Form.Control
                                        as="textarea"
                                        name="commentsForPrescription"
                                        value={
                                            addEyeTestConfig.commentsForPrescription
                                        }
                                        onChange={handleTextareaChange}
                                        rows={3}
                                        type="text"
                                        placeholder={t('inputText')}
                                        isInvalid={
                                            charLimitErrors.commentsForPrescription
                                        }
                                        style={{
                                            overflow: 'auto',
                                            resize: 'none',
                                        }}
                                    />
                                )}

                                <div className="d-flex justify-content-between mt-1">
                                    <Form.Text className="text-muted">
                                        {addEyeTestConfig
                                            .commentsForPrescription?.length ||
                                            0}
                                        / 500 caractères
                                    </Form.Text>
                                    {charLimitErrors.commentsForPrescription && (
                                        <Form.Text className="text-danger">
                                            500 caractères maximum autorisés
                                        </Form.Text>
                                    )}
                                </div>
                            </Form.Group>
                        </Col>
                        <Col
                            md={6}
                            className={`${view === 'view' ? 'custom_disabled' : ''}`}
                        >
                            <Form.Group className="mb-5">
                                <Form.Label>
                                    {t('additionalComments')}
                                </Form.Label>

                                {view === 'view' ? (
                                    // ✅ VIEW MODE — clickable links + copyable text
                                    <div
                                        className="border rounded p-2"
                                        style={{
                                            minHeight: '100px',
                                            whiteSpace: 'pre-wrap',
                                            overflowY: 'auto',
                                            resize: 'none',
                                            cursor: 'text',
                                            backgroundColor: '#f8f9fa',
                                            userSelect: 'text',
                                            pointerEvents: 'auto',
                                        }}
                                        onClick={() => {
                                            navigator.clipboard.writeText(
                                                addEyeTestConfig.noteOpt || ''
                                            );
                                        }}
                                        title="Click to copy content"
                                        dangerouslySetInnerHTML={{
                                            __html: (
                                                addEyeTestConfig.noteOpt || ''
                                            ).replace(
                                                /(https?:\/\/[^\s]+)/g,
                                                '<a href="$1" target="_blank" rel="noopener noreferrer" style="color: #0d6efd; text-decoration: underline;">$1</a>'
                                            ),
                                        }}
                                    ></div>
                                ) : (
                                    // ✅ EDIT MODE — normal textarea
                                    <Form.Control
                                        as="textarea"
                                        name="noteOpt"
                                        rows={3}
                                        type="text"
                                        value={addEyeTestConfig.noteOpt}
                                        onChange={handleTextareaChange}
                                        placeholder={t('inputText')}
                                        isInvalid={charLimitErrors.noteOpt}
                                        style={{
                                            overflow: 'auto',
                                            resize: 'none',
                                        }}
                                    />
                                )}

                                <div className="d-flex justify-content-between mt-1">
                                    <Form.Text className="text-muted">
                                        {addEyeTestConfig.noteOpt?.length || 0}/
                                        500 caractères
                                    </Form.Text>
                                    {charLimitErrors.noteOpt && (
                                        <Form.Text className="text-danger">
                                            500 caractères maximum autorisés
                                        </Form.Text>
                                    )}
                                </div>
                            </Form.Group>
                        </Col>
                        <Col
                            md={12}
                            className={`${view == 'view' ? 'custom_disabled' : ''}`}
                        >
                            <Form.Group className="mb-3 eye_test_switch">
                                <Form.Label className="m-0">
                                    {t('freeAct')}
                                </Form.Label>
                                <Form.Check
                                    type="switch"
                                    name="acteGratuit"
                                    checked={addEyeTestConfig.acteGratuit}
                                    onChange={(e) => {
                                        setAddEyeTestConfig((prev) => {
                                            return {
                                                ...prev,
                                                acteGratuit: e.target.checked,
                                            };
                                        });
                                    }}
                                />
                            </Form.Group>
                        </Col>
                        <Col
                            md={12}
                            className={`${view == 'view' ? 'custom_disabled' : ''}`}
                        >
                            <Form.Group className="mb-3">
                                <Form.Label className="m-0">
                                    {t('needPrescription')}*
                                </Form.Label>
                                <Form.Select
                                    aria-label="Default"
                                    name="needPrescription"
                                    onChange={(e) => {
                                        setAddEyeTestConfig((prev) => {
                                            return {
                                                ...prev,
                                                needPrescription:
                                                    e.target.value == 'true'
                                                        ? true
                                                        : false,
                                            };
                                        });
                                    }}
                                    value={addEyeTestConfig.needPrescription}
                                    required
                                >
                                    <option disabled value={''}>
                                        {t('selectItem')}
                                    </option>
                                    <option value={true}>{t('yes')}</option>
                                    <option value={false}>{t('no')}</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        {(
                            (
                                (user?.userType === 'BACKOFFICE' || user?.userType === 'ADMIN') &&
                                !addEyeTestConfig?.infoCommentaireInterne === ""
                            ) ||
                            (user?.userType === 'OPTICIAN' && !user?.isExternal)
                        ) && (
                                <>
                                    <Col
                                        md={12}
                                        className={`${view == 'view' ? 'custom_disabled' : ''}`}
                                    >
                                        <Form.Group className="mb-5">
                                            <Form.Label>
                                                {t('commentaireInterne')}
                                            </Form.Label>

                                            {view === 'view' ? (
                                                // ✅ VIEW MODE — clickable links + copyable
                                                <div
                                                    className="border rounded p-2"
                                                    style={{
                                                        minHeight: '100px',
                                                        whiteSpace: 'pre-wrap',
                                                        overflowY: 'auto',
                                                        resize: 'none',
                                                        cursor: 'text',
                                                        backgroundColor: '#f8f9fa',
                                                        userSelect: 'text',
                                                        pointerEvents: 'auto',
                                                    }}
                                                    onClick={() => {
                                                        navigator.clipboard.writeText(
                                                            addEyeTestConfig.infoCommentaireInterne ||
                                                            '-'
                                                        );
                                                    }}
                                                    title="Click to copy content"
                                                    dangerouslySetInnerHTML={{
                                                        __html: (
                                                            addEyeTestConfig.infoCommentaireInterne ||
                                                            '-'
                                                        ).replace(
                                                            /(https?:\/\/[^\s]+)/g,
                                                            '<a href="$1" target="_blank" rel="noopener noreferrer" style="color: #0d6efd; text-decoration: underline;">$1</a>'
                                                        ),
                                                    }}
                                                ></div>
                                            ) : (
                                                // ✅ EDIT MODE — normal textarea
                                                <Form.Control
                                                    as="textarea"
                                                    name="commentaireInterne"
                                                    value={
                                                        addEyeTestConfig.commentaireInterne
                                                    }
                                                    onChange={handleTextareaChange}
                                                    rows={3}
                                                    type="text"
                                                    placeholder={t('inputText')}
                                                    isInvalid={
                                                        charLimitErrors.commentaireInterne
                                                    }
                                                    style={{
                                                        overflow: 'auto',
                                                        resize: 'none',
                                                    }}
                                                />
                                            )}

                                            <div className="d-flex justify-content-between mt-1">
                                                <Form.Text className="text-muted">
                                                    {view === 'view'
                                                        ? addEyeTestConfig
                                                            .infoCommentaireInterne
                                                            ?.length || 0
                                                        : addEyeTestConfig
                                                            .commentaireInterne
                                                            ?.length || 0}
                                                    / 500 caractères
                                                </Form.Text>
                                                {charLimitErrors.commentaireInterne && (
                                                    <Form.Text className="text-danger">
                                                        500 caractères maximum
                                                        autorisés
                                                    </Form.Text>
                                                )}
                                            </div>
                                        </Form.Group>
                                    </Col>
                                </>
                            )}
                            {!user?.isExternal ? (
                            <>
                        <Col
                            md={6}
                            className={`${view == 'view' ? 'custom_disabled' : ''}`}
                        >
                            <Form.Group className="mb-3">
                                <Form.Label className="m-0">
                                    {t('Imagesrétino')}*
                                </Form.Label>
                                {
                                    view == "view" && addEyeTestConfig.isImageRetino == "" || addEyeTestConfig.isImageRetino == null ?

                                        (
                                            <Form.Select
                                                aria-label="Default"
                                                name="doYouWearGlasses"
                                                value={
                                                    "N/A"
                                                }
                                            >
                                                <option value={"N/A"}>N/A</option>
                                            </Form.Select>
                                        ) :

                                        (<Form.Select
                                            aria-label="Default"
                                            name="isImageRetino"
                                            onChange={(e) => {
                                                setAddEyeTestConfig((prev) => ({
                                                    ...prev,
                                                    isImageRetino:
                                                        e.target.value,
                                                }));
                                            }}
                                            value={
                                                addEyeTestConfig.isImageRetino
                                            }
                                            required
                                        >
                                            <option disabled value={''}>
                                                {t('selectItem')}
                                            </option>
                                            <option value="Yes">
                                                {t('yes')}
                                            </option>
                                            <option value="No">
                                                {t('no')}
                                            </option>
                                        </Form.Select>
                                        )
                                }
                            </Form.Group>
                        </Col>
                        {addEyeTestConfig.isImageRetino == 'No' && (
                            <Col
                                md={6}
                                className={`${view == 'view' ? 'custom_disabled' : ''}`}
                            >
                                <Form.Group className="mb-5">
                                    <Form.Label>
                                        {t(
                                            'Si non, veuillez spécifier'
                                        )}{' '}
                                        *
                                    </Form.Label>
                                    <Form.Select
                                        aria-label="Default"
                                        name="imageRetinoSpecification"
                                        onChange={(e) => {
                                            setAddEyeTestConfig(
                                                (prev) => ({
                                                    ...prev,
                                                    imageRetinoSpecification:
                                                        e.target.value,
                                                })
                                            );
                                        }}
                                        value={
                                            addEyeTestConfig.imageRetinoSpecification
                                        }
                                        required
                                    >
                                        <option disabled value={''}>
                                            {t('selectItem')}
                                        </option>
                                        <option value="Problème technique">
                                            Problème technique
                                        </option>
                                        <option value="Pupille trop grosse">
                                            Pupille trop grosse
                                        </option>
                                        <option value="Dimensions de la tête du patient">
                                            Dimensions de la tête du
                                            patient
                                        </option>
                                        <option value="Positionnement incorrect du patient">
                                            Positionnement incorrect du
                                            patient
                                        </option>
                                        <option value="Autre">
                                            Autre
                                        </option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        )}
</>):null}

                        {user?.userType !== 'EYEDOCTOR' ? (
                            <Col
                                md={6}
                                className={`${view == 'view' ? 'custom_disabled' : ''}`}
                            >
                                <Form.Group className="mb-5">
                                    <Form.Label>
                                        {t('mutualCompany')}
                                    </Form.Label>

                                    {view === 'view' ? (
                                        // ✅ VIEW MODE — clickable links + copyable text
                                        <div
                                            className="border rounded p-2"
                                            style={{
                                                minHeight: '100px',
                                                whiteSpace: 'pre-wrap',
                                                overflowY: 'auto',
                                                resize: 'none',
                                                cursor: 'text',
                                                backgroundColor: '#f8f9fa',
                                                userSelect: 'text',
                                                pointerEvents: 'auto',
                                            }}
                                            onClick={() => {
                                                navigator.clipboard.writeText(
                                                    addEyeTestConfig.isMutualCompany ||
                                                    ''
                                                );
                                            }}
                                            title="Click to copy content"
                                            dangerouslySetInnerHTML={{
                                                __html: (
                                                    addEyeTestConfig.isMutualCompany ||
                                                    ''
                                                ).replace(
                                                    /(https?:\/\/[^\s]+)/g,
                                                    '<a href="$1" target="_blank" rel="noopener noreferrer" style="color: #0d6efd; text-decoration: underline;">$1</a>'
                                                ),
                                            }}
                                        ></div>
                                    ) : (
                                        // ✅ EDIT MODE — normal textarea
                                        <Form.Control
                                            as="textarea"
                                            name="isMutualCompany"
                                            value={
                                                addEyeTestConfig.isMutualCompany
                                            }
                                            onChange={handleTextareaChange}
                                            rows={3}
                                            type="text"
                                            placeholder={t('inputText')}
                                            isInvalid={
                                                charLimitErrors.isMutualCompany
                                            }
                                            style={{
                                                overflow: 'auto',
                                                resize: 'none',
                                            }}
                                        />
                                    )}

                                    <div className="d-flex justify-content-between mt-1">
                                        <Form.Text className="text-muted">
                                            {addEyeTestConfig.isMutualCompany
                                                ?.length || 0}
                                            / 500 caractères
                                        </Form.Text>
                                        {charLimitErrors.isMutualCompany && (
                                            <Form.Text className="text-danger">
                                                500 caractères maximum autorisés
                                            </Form.Text>
                                        )}
                                    </div>
                                </Form.Group>
                            </Col>
                        ) : null}
                        {glass == false ? (
                            <Col
                                md={6}
                                className={`${view == 'view' ? 'custom_disabled' : ''}`}
                            >
                                <Form.Group className="mb-5">
                                    <Form.Label>
                                        {t('lensSpecification')}*
                                    </Form.Label>

                                    {view === 'view' ? (
                                        // ✅ VIEW MODE — clickable links + copyable
                                        <div
                                            className="border rounded p-2"
                                            style={{
                                                minHeight: '100px',
                                                whiteSpace: 'pre-wrap',
                                                overflowY: 'auto',
                                                resize: 'none',
                                                cursor: 'text',
                                                backgroundColor: '#f8f9fa',
                                                userSelect: 'text',
                                                pointerEvents: 'auto',
                                            }}
                                            onClick={() => {
                                                navigator.clipboard.writeText(
                                                    addEyeTestConfig.commentForLenses ||
                                                    ''
                                                );
                                            }}
                                            title="Click to copy content"
                                            dangerouslySetInnerHTML={{
                                                __html: (
                                                    addEyeTestConfig.commentForLenses ||
                                                    ''
                                                ).replace(
                                                    /(https?:\/\/[^\s]+)/g,
                                                    '<a href="$1" target="_blank" rel="noopener noreferrer" style="color: #0d6efd; text-decoration: underline;">$1</a>'
                                                ),
                                            }}
                                        ></div>
                                    ) : (
                                        // ✅ EDIT MODE — normal textarea
                                        <Form.Control
                                            as="textarea"
                                            name="commentForLenses"
                                            value={
                                                addEyeTestConfig.commentForLenses
                                            }
                                            onChange={handleTextareaChange}
                                            rows={3}
                                            type="text"
                                            placeholder={t('inputText')}
                                            required
                                            isInvalid={
                                                charLimitErrors.commentForLenses
                                            }
                                            style={{
                                                overflow: 'auto',
                                                resize: 'none',
                                            }}
                                        />
                                    )}

                                    <div className="d-flex justify-content-between mt-1">
                                        <Form.Text className="text-muted">
                                            {addEyeTestConfig.commentForLenses
                                                ?.length || 0}
                                            / 500 caractères
                                        </Form.Text>
                                        {charLimitErrors.commentForLenses && (
                                            <Form.Text className="text-danger">
                                                500 caractères maximum autorisés
                                            </Form.Text>
                                        )}
                                    </div>
                                </Form.Group>
                            </Col>
                        ) : (
                            ''
                        )}

                        {user?.userType === 'OPTICIAN' &&
                            user?.isOpticianExpressAccess === true && (
                                <Col
                                    md={6}
                                    className={`${view == 'view' ? 'custom_disabled' : ''}`}
                                >
                                    <Form.Group className="mb-5">
                                        <Form.Label>
                                            {t('expressTest')}*
                                        </Form.Label>
                                        <Form.Select
                                            aria-label="Default"
                                            name="isExpressTest"
                                            onChange={(e) => {
                                                setAddEyeTestConfig((prev) => ({
                                                    ...prev,
                                                    isExpressTest:
                                                        e.target.value ===
                                                            'true'
                                                            ? true
                                                            : false,
                                                }));
                                            }}
                                            value={addEyeTestConfig?.isExpressTest?.toString()} // Ensure it always has a value
                                            required
                                        >
                                            <option value="false">
                                                {t('no')}
                                            </option>
                                            <option value="true">
                                                {t('yes')}
                                            </option>
                                        </Form.Select>
                                        {addEyeTestConfig.isExpressTest && (
                                            <Form.Label
                                                className="m-0"
                                                style={{
                                                    whiteSpace: 'normal',
                                                    fontWeight: '400',
                                                    display: 'inline',
                                                }}
                                            >
                                                {t('expressTestDisclaimer')}
                                            </Form.Label>
                                        )}
                                    </Form.Group>
                                </Col>
                            )}

                        {view == 'view' &&
                            (addEyeTestConfig?.comment ||
                                user?.userType == 'EYEDOCTOR') ? (
                            <Col
                                md={12}
                                className={`${view == 'view' &&
                                    user?.userType !== 'EYEDOCTOR'
                                    ? 'view-scroll-textareae'
                                    : ''
                                    }`}
                            >
                                <Form.Group
                                    className={`mb-5 ${error?.comment ? 'error_input' : ''}`}
                                >
                                    <Form.Label>
                                        {t('doctorCommentForOptician')}
                                    </Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        name="comment"
                                        value={addEyeTestConfig?.comment}
                                        onChange={handleTextareaChange}
                                        rows={3}
                                        type="text"
                                        placeholder={t('inputText')}
                                        isInvalid={charLimitErrors.comment}
                                    />
                                    <div className="d-flex justify-content-between mt-1">
                                        <Form.Text className="text-muted">
                                            {addEyeTestConfig.comment?.length ||
                                                0}
                                            / 500 caractères
                                        </Form.Text>
                                        {charLimitErrors.comment && (
                                            <Form.Text className="text-danger">
                                                500 caractères maximum autorisés
                                            </Form.Text>
                                        )}
                                    </div>
                                    {error?.comment && (
                                        <Form.Control.Feedback type="invalid">
                                            {t('mustEnterValue')}
                                        </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                            </Col>
                        ) : (
                            ''
                        )}

                        {user?.userType !== 'OPTICIAN' ?

                            <>
                                {addEyeTestConfig?.status === 'Approved' || user?.userType === 'EYEDOCTOR' ?
                                    <>
                                        {view == 'view' && (
                                            <Col
                                                md={12}
                                                className={`${view == 'view' &&
                                                    user?.userType !== 'EYEDOCTOR'
                                                    ? 'custom_disabled'
                                                    : user?.userType === 'EYEDOCTOR' &&
                                                        addEyeTestConfig?.status ===
                                                        'Approved'
                                                        ? 'custom_disabled'
                                                        : ''
                                                    }`}
                                            >
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="m-0">
                                                        {t("Générer lettre d'adressage")}
                                                    </Form.Label>
                                                    <Form.Select
                                                        aria-label="Default"
                                                        name="isDoctorNewComment"
                                                        onChange={(e) => {
                                                            setAddEyeTestConfig((prev) => {
                                                                return {
                                                                    ...prev,
                                                                    isDoctorNewComment:
                                                                        e.target.value == 'true'
                                                                            ? true
                                                                            : false,
                                                                };
                                                            });
                                                        }}
                                                        value={
                                                            addEyeTestConfig.isDoctorNewComment
                                                        }
                                                        required
                                                    >
                                                        <option disabled value={''}>
                                                            {t('selectItem')}
                                                        </option>
                                                        <option value={true}>{t('yes')}</option>
                                                        <option value={false}>{t('no')}</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        )}
                                    </>
                                    : null}
                            </>
                            : null}
                        {view == 'view' &&
                            addEyeTestConfig?.isDoctorNewComment && user?.userType !== 'OPTICIAN' ? (
                            <Col
                                md={12}
                                className={`${view == 'view' &&
                                    user?.userType !== 'EYEDOCTOR'
                                    ? 'custom_disabled'
                                    : user?.userType === 'EYEDOCTOR' &&
                                        addEyeTestConfig?.status ===
                                        'Approved'
                                        ? 'custom_disabled'
                                        : ''
                                    }`}
                            >
                                <Form.Group
                                    className={`mb-5 ${error?.comment ? 'error_input' : ''}`}
                                >
                                    <Form.Label>
                                        {t(
                                            'Motif à indiquer sur le document'
                                        )}
                                    </Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        name="doctorNewComment"
                                        value={
                                            addEyeTestConfig?.doctorNewComment
                                        }
                                        onChange={handleTextareaChange}
                                        rows={3}
                                        type="text"
                                        placeholder={t('inputText')}
                                        isInvalid={
                                            charLimitErrors.doctorNewComment
                                        }
                                    />
                                    <div className="d-flex justify-content-between mt-1">
                                        <Form.Text className="text-muted">
                                            {addEyeTestConfig.doctorNewComment
                                                ?.length || 0}
                                            / 500 caractères
                                        </Form.Text>
                                        {charLimitErrors.doctorNewComment && (
                                            <Form.Text className="text-danger">
                                                500 caractères maximum autorisés
                                            </Form.Text>
                                        )}
                                    </div>
                                    {error?.comment && (
                                        <Form.Control.Feedback type="invalid">
                                            {t('mustEnterValue')}
                                        </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                            </Col>
                        ) : (
                            ''
                        )}

                        {consent && (
                            <Col
                                md={12}
                                className={`${view == 'view' ? 'custom_disabled' : ''}`}
                            >
                                <Form.Group
                                    className={`mb-3 ${error?.infoPrescriptionToOptician
                                        ? 'error_input'
                                        : ''
                                        }`}
                                >
                                    <div
                                        className="custom_label"
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '0px',
                                        }}
                                    >
                                        <Form.Check
                                            type="checkbox"
                                            name="infoPrescriptionToOptician"
                                            style={{
                                                width: '20px',
                                                height: '20px',
                                                margin: '6px',
                                                padding: 0,
                                                transform: 'scale(1.5)',
                                            }}
                                            checked={
                                                addEyeTestConfig.infoPrescriptionToOptician
                                            }
                                            onChange={(e) => {
                                                setAddEyeTestConfig((prev) => {
                                                    return {
                                                        ...prev,
                                                        infoPrescriptionToOptician:
                                                            e.target.checked,
                                                    };
                                                });
                                            }}
                                        />
                                        <span style={{ lineHeight: 'normal' }}>
                                            Partage automatique de prescription
                                        </span>
                                    </div>
                                    <Form.Label
                                        className="m-0"
                                        style={{
                                            whiteSpace: 'normal',
                                            fontWeight: '400',
                                            display: 'inline',
                                        }}
                                    >
                                        {t('confirmationText')}
                                    </Form.Label>
                                    {error?.infoPrescriptionToOptician && (
                                        <Form.Control.Feedback type="invalid">
                                            {t('checkBoxErrorToSubmitTest')}
                                        </Form.Control.Feedback>
                                    )}
                                </Form.Group>
                            </Col>
                        )}
                    </Row>
                </Card.Body>
            </Card>
        </div>
    );
};
export default Step4;
